import '../assets/styles/modalinfos.scss'
import notDelete from "../assets/img/Icon awesome-exclamation-circle.svg";

export function ModalSure(props) {

    return (
        <div id="modal-container">
            <input style={{ display: 'none' }} type='checkbox' checked={props.checked} id='button' />
            <div className='modal'>
                <div className='content'>
                    <div className='body-modal-delete'>
                        <img src={notDelete} alt="Icone" />
                        <span className="modal-remove-span">{props.label}</span>
                        <div className="modal-remove-buttons">
                            <button  onClick={props.onClick} className="button dont">Não</button>
                            <button  onClick={props.delete} className="button yes">Sim</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}